export default __webpack_public_path__ + "static/media/image-translator.c6da22c8.webp";